import * as actions from "./actionTypes";
import * as config from "config";
import ObjectToQueryString, { customQueryJoiner } from 'utils/ObjectToQueryString';

export function getPayrolls(params, customQuery = "") {
    const appendQuery = customQuery !== "" ? customQueryJoiner(ObjectToQueryString(params)) + customQuery : "";
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + ObjectToQueryString(params) + appendQuery,
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLLS_START,
            onSuccess: actions.GET_PAYROLLS,
            onError: actions.GET_PAYROLLS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getPayrollAnalytics() {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls,
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_ANALYTICS_START,
            onSuccess: actions.GET_PAYROLL_ANALYTICS,
            onError: actions.GET_PAYROLL_ANALYTICS_FAILED,
        },
    }
}

export function downloadGetPayrolls(params, customQuery = "") {
    const appendQuery = customQuery !== "" ? customQueryJoiner(ObjectToQueryString(params)) + customQuery : "";
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + ObjectToQueryString(params) + appendQuery,
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_GET_PAYROLLS_START,
            onSuccess: actions.DOWNLOAD_GET_PAYROLLS,
            onError: actions.DOWNLOAD_GET_PAYROLLS_FAILED,
        },
    }
}

export function createPayroll(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiCreatePayroll,
            method: "post",
            data: params,
            onStart: actions.CREATE_PAYROLL_START,
            onSuccess: actions.CREATE_PAYROLL,
            onError: actions.CREATE_PAYROLL_FAILED,
        },
    }
}

export function resetCreatePayroll() {
    return {
        type: actions.CREATE_PAYROLL_RESET,
        payload: {},
    }
}

export function getPayrollDetails(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id,
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_DETAILS_START,
            onSuccess: actions.GET_PAYROLL_DETAILS,
            onError: actions.GET_PAYROLL_DETAILS_FAILED,
        },
    }
}

export function getPayrollTaxAndDeductionSummary(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/tax-deduction-summary",
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_TAX_AND_DEDUCTION_SUMMARY_START,
            onSuccess: actions.GET_PAYROLL_TAX_AND_DEDUCTION_SUMMARY,
            onError: actions.GET_PAYROLL_TAX_AND_DEDUCTION_SUMMARY_FAILED,
        },
    }
}

export function getPayrollTransactions(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/transactions" + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.GET_PAYROLL_TRANSACTIONS,
            onError: actions.GET_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function downloadPayrollTransactions(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/transactions" + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.DOWNLOAD_PAYROLL_TRANSACTIONS,
            onError: actions.DOWNLOAD_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function generatePayrollTransactions(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/generate-transactions",
            method: "put",
            data: {},
            onStart: actions.GENERATE_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.GENERATE_PAYROLL_TRANSACTIONS,
            onError: actions.GENERATE_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function resetGeneratePayrollTransactions() {
    return {
        type: actions.GENERATE_PAYROLL_TRANSACTIONS_RESET,
        payload: {},
    }
}

export function updateManualBonus(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiPayrollTransaction + id + "/manual-bonus",
            method: "put",
            data: params,
            onStart: actions.UPDATE_PAYROLL_TRANSACTION_START,
            onSuccess: actions.UPDATE_PAYROLL_TRANSACTION,
            onError: actions.UPDATE_PAYROLL_TRANSACTION_FAILED,
        },
    }
}

export function updateManualDeduction(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiPayrollTransaction + id + "/manual-deductions",
            method: "put",
            data: params,
            onStart: actions.UPDATE_PAYROLL_TRANSACTION_START,
            onSuccess: actions.UPDATE_PAYROLL_TRANSACTION,
            onError: actions.UPDATE_PAYROLL_TRANSACTION_FAILED,
        },
    }
}

export function resetUpdateManualBonusDeduction() {
    return {
        type: actions.UPDATE_PAYROLL_TRANSACTION_RESET,
        payload: {},
    }
}

export function sendPayrollForReview(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/status/review",
            method: "patch",
            data: {},
            onStart: actions.UPDATE_PAYROLL_STATUS_START,
            onSuccess: actions.UPDATE_PAYROLL_STATUS,
            onError: actions.UPDATE_PAYROLL_STATUS_FAILED,
        },
    }
}

export function updatePayrollStatus(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/status",
            method: "patch",
            data: params,
            onStart: actions.UPDATE_PAYROLL_STATUS_START,
            onSuccess: actions.UPDATE_PAYROLL_STATUS,
            onError: actions.UPDATE_PAYROLL_STATUS_FAILED,
        },
    }
}

export function resetUpdatePayrollStatus() {
    return {
        type: actions.UPDATE_PAYROLL_STATUS_RESET,
        payload: {},
    }
}

export function paySalary(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/pay-salaries",
            method: "post",
            data: params,
            onStart: actions.PAYROLL_PAY_SALARY_START,
            onSuccess: actions.PAYROLL_PAY_SALARY,
            onError: actions.PAYROLL_PAY_SALARY_FAILED,
        },
    }
}

export function resetPaySalary() {
    return {
        type: actions.PAYROLL_PAY_SALARY_RESET,
        payload: {},
    }
}

export function getRemittances(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/payable-remittances",
            method: "get",
            data: {},
            onStart: actions.PAYROLL_GET_REMITTANCES_START,
            onSuccess: actions.PAYROLL_GET_REMITTANCES,
            onError: actions.PAYROLL_GET_REMITTANCES_FAILED,
        },
    }
}

export function payRemittance(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/pay-remittance",
            method: "post",
            data: params,
            onStart: actions.PAYROLL_PAY_REMITTANCE_START,
            onSuccess: actions.PAYROLL_PAY_REMITTANCE,
            onError: actions.PAYROLL_PAY_REMITTANCE_FAILED,
        },
    }
}

export function resetPayRemittance() {
    return {
        type: actions.PAYROLL_PAY_REMITTANCE_RESET,
        payload: {},
    }
}

export function deletePayroll(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetPayrolls + "/" + id + "/status",
            method: "delete",
            data: {},
            onStart: actions.DELETE_PAYROLL_STATUS_START,
            onSuccess: actions.DELETE_PAYROLL_STATUS,
            onError: actions.DELETE_PAYROLL_STATUS_FAILED,
        },
    }
}

export function resetDeletePayroll() {
    return {
        type: actions.DELETE_PAYROLL_STATUS_RESET,
        payload: {},
    }
}
